export const ORGANISATION_DATA_EDIT_FORM_FIELDS = [
  {
    id: 1,
    name: 'description',
    title: 'Наименование организации:',
  },
  {
    id: 2,
    name: 'vatNumber',
    title: 'УНП:',
  },
  {
    id: 3,
    name: 'shortLegalName',
    title: 'Краткое наименование организации:',
  },
  {
    id: 4,
    name: 'fullLegalName',
    title: 'Полное наименование организации:',
  },
  {
    id: 5,
    name: 'legalAddress',
    title: 'Юр. адрес:',
  },
  {
    id: 6,
    name: 'postalAddress',
    title: 'Почтовый адрес:',
  },
  {
    id: 7,
    name: 'phoneNumber',
    title: 'Телефон:',
  },
  {
    id: 8,
    name: 'email',
    title: 'Email:',
  },
  {
    id: 9,
    name: 'emailDistribution',
    title: 'Email для рассылки:',
  },
  {
    id: 10,
    name: 'registrationDate',
    title: 'Дата регистрации в системе:',
  },
  {
    id: 11,
    name: 'ipRegistrationDate',
    title: 'Дата регистрации предприятия:',
  },
  {
    id: 12,
    name: 'signatoryFullName',
    title: 'Кто подписывает документы:',
  },
  {
    id: 13,
    name: 'signatoryOperatesUnder',
    title: 'Основание',
  },
  {
    id: 14,
    name: 'signatoryPosition',
    title: 'Должность',
  },
]
